import { FieldWrapper, InputText } from '@dixa/lib-shared-habla';
import { ComponentPropsWithRef } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import {
  HookFormFieldWrappedBaseProps,
  useHookFormFieldWrapper,
} from 'utils/hookForm';

/** Represents the React Hook Form variant of the {@link InputText} component. */
export const HookFormText = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: HookFormFieldWrappedBaseProps<
    TFieldValues,
    TName,
    ComponentPropsWithRef<typeof InputText>
  >,
): JSX.Element => {
  const { controller, controllerProps, fieldWrapperProps } =
    useHookFormFieldWrapper(props);

  return (
    <FieldWrapper {...fieldWrapperProps}>
      <InputText
        {...props.componentProps}
        {...controller.field}
        onBlur={(event) => {
          props.componentProps?.onBlur?.(event);
          controller.field.onBlur();
        }}
        onChange={(event) => {
          props.componentProps?.onChange?.(event);

          controller.field.onChange(
            props.componentProps?.type === 'number'
              ? event.target.valueAsNumber
              : event,
          );
        }}
        id={controllerProps.name}
        aria-disabled={fieldWrapperProps.disabled}
        disabled={fieldWrapperProps.disabled}
        aria-required={fieldWrapperProps.required}
        required={fieldWrapperProps.required}
        status={FieldWrapper.getStatus(fieldWrapperProps.meta)}
      />
    </FieldWrapper>
  );
};
